import React, { useEffect, useState } from "react";
import { getLessons } from "../api";
import LessonSections from "../components/LessonSections";

const PAGE_SIZE = 10;

export default function Archive() {
  const [lessons, setLessons] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getLessons({ page, pageSize: PAGE_SIZE })
      .then((data) => {
        setLessons(data.lessons);
        setTotal(data.total);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  if (selected) {
    return (
      <div className="page">
        <button className="back-link" onClick={() => setSelected(null)}>
          &larr; Back to archive
        </button>
        <LessonSections lesson={selected} />
      </div>
    );
  }

  return (
    <div className="page">
      <h1>Archive</h1>
      {error && <p className="error">{error}</p>}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <ul className="archive-list">
          {lessons.map((lesson) => (
            <li key={lesson.date} className="archive-item" onClick={() => setSelected(lesson)}>
              <p className="archive-date">{lesson.date}</p>
              <h3>{lesson.topic}</h3>
              <p className="archive-summary">{lesson.summary}</p>
            </li>
          ))}
        </ul>
      )}

      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
          Previous
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)}>
          Next
        </button>
      </div>
    </div>
  );
}
